module.exports = __webpack_public_path__ + "fromGroomToParents-we-n.44aabba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-we-n.jpg
// module id = bQ6+
// module chunks = 0